import { APIClient } from "../../base";
import { PaginationInterface } from "../../../../interfaces/PaginationInterface";

const LogV1Api = {
    getAll: async (pagination: PaginationInterface) => await APIClient.get('/v1/logs', pagination),
    getDetail: async (id: number | string) => await APIClient.get('/v1/logs/' + encodeURIComponent(String(id)), {}),
};

export default LogV1Api;
